import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import img from '../img/image.png'
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RigthIcon from '@mui/icons-material/ArrowForward';
import Markdown from 'react-markdown';
import { Link } from 'react-router-dom';


function Contract({ locale, content }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    let contract = locale == 'ru' ? 'Направления работы' : 'areas of work';
    return (
        <div >
            <Box bgcolor={'#E1EEFF'} pt='20px' pb='100px'>
                <Container>
                    <Typography gutterBottom variant="h4" component="div" className='block_title'  sx={{paddingTop: "100px"}}>
                        {content?.title || ''}
                    </Typography>
                    <Grid container spacing={2} sx={{justifyContent: { xs: 'center', xl: 'start' } }}>
                        <Grid size={{ xs: 12, md: 6 }} ><img alt='img'  width='500px' className='mainPageImg' src={content?.images ? API_URL+content.images[0].url : img}></img></Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='mainText' component="div">
                                <Markdown>{content?.text || ''}</Markdown>
                            </Typography>
                            <Box width='100%' display='flex' justifyContent='center' mt='50px'>
                                <Button variant='contained' sx={{ m: '10px 4px', backgroundColor: '#5281B5', fontSize: '24px' }} >
                                    <Link to='/contract-production'>{contract}<RigthIcon m={2} /></Link>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </div>
    );
}
export default Contract;
